export * from './app-side-bar.component';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-side-bar/index.ts